<!-- Header -->
<mat-card class="no-overflow cross-key-dialog">
  <mat-card-header class="flex-space center" style="border-bottom: 1px solid lightgray">
    <mat-card-title>Create Cylinder</mat-card-title>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <!-- Content -->

  <mat-card-content [padding]="0">
    <form [formGroup]="crossKeyForm" (keyup.enter)="create()">
      <!-- Reason -->
      <div class="row padding all">
        <mat-form-field class="fill padding sm right left">
          <mat-label
            [ngClass]="{
              'error-message': fieldHasError(crossKeyForm, 'name'),
              focus: focus.name
            }"
          >
            Name
            <span *ngIf="lastCrossKey?.keySetSymbol">( Last used: {{ lastCrossKey?.keySetSymbol }} )</span></mat-label
          >

          <div
            class="form-input"
            [ngClass]="{
              error: fieldHasError(crossKeyForm, 'name'),
              disabled: false,
              'focus-border': focus.name
            }"
          >
            <input
              id="name"
              placeholder="Enter Cross Key Name"
              formControlName="name"
              (focus)="focusOn('name')"
              (focusout)="focusOn('name')"
              class="uppercase"
              aria-describedby="name errors"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(crossKeyForm, 'name')" [size]="24" [color]="'#EE6352'">warning </mat-icon>
          </div>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.name" id="nameErrors">
            <div class="caption error-message" *ngIf="fieldHasErrorMessages(crossKeyForm, validation, 'name')">
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-stroked-button id="cancel" (click)="close()">Cancel</button>
      <button
        type="submit"
        (click)="create()"
        class="margin left"
        [disabled]="!crossKeyForm.valid"
        mat-stroked-button
        id="create"
      >
        Create
      </button>
    </div>
  </mat-card-actions>
</mat-card>
